import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon24: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M15.5 0C15.776 0 16 0.224 16 0.5V2.003L17.5 2.004C18.881 2.004 20 3.123 20 4.504V17.506C20 18.887 18.881 20.006 17.5 20.006H2.5C1.119 20.006 0 18.887 0 17.506V4.504C0 3.123 1.119 2.004 2.5 2.004L4 2.003V0.5C4 0.224 4.224 0 4.5 0C4.776 0 5 0.224 5 0.5V2.003H15V0.5C15 0.224 15.224 0 15.5 0ZM19 8.02699H1V17.506C1 18.335 1.672 19.006 2.5 19.006H17.5C18.328 19.006 19 18.335 19 17.506V8.02699ZM13.84 10.634C14.042 10.823 14.053 11.139 13.865 11.341L9.203 16.341C9.007 16.55 8.677 16.553 8.478 16.348L6.14101 13.933C5.94901 13.735 5.955 13.418 6.153 13.226C6.352 13.034 6.668 13.039 6.86 13.238L8.83 15.274L13.134 10.659C13.322 10.457 13.638 10.446 13.84 10.634ZM4 3.003L2.5 3.004C1.672 3.004 1 3.675 1 4.504V7.02699H19V4.504C19 3.675 18.328 3.004 17.5 3.004L16 3.003V4.5C16 4.776 15.776 5 15.5 5C15.224 5 15 4.776 15 4.5V3.003H5V4.5C5 4.776 4.776 5 4.5 5C4.224 5 4 4.776 4 4.5V3.003Z"
        fill="#73C177"
      />
    </Icon>
  )
}
